var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVisa(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_65:169)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6644 8.03235C12.9603 8.03235 11.4375 8.91561 11.4375 10.5475C11.4375 12.419 14.1383 12.5482 14.1383 13.4884C14.1383 13.8843 13.6846 14.2387 12.9098 14.2387C11.8101 14.2387 10.9883 13.7435 10.9883 13.7435L10.6366 15.3903C10.6366 15.3903 11.5834 15.8085 12.8404 15.8085C14.7035 15.8085 16.1696 14.8819 16.1696 13.2221C16.1696 11.2445 13.4575 11.1191 13.4575 10.2465C13.4575 9.93637 13.8299 9.59659 14.6025 9.59659C15.4743 9.59659 16.1855 9.9567 16.1855 9.9567L16.5297 8.3662C16.5297 8.3662 15.7558 8.03235 14.6644 8.03235ZM-0.926404 8.15239L-0.967667 8.39246C-0.967667 8.39246 -0.250751 8.52367 0.394947 8.7854C1.22634 9.08552 1.28556 9.26024 1.42558 9.8029L2.95137 15.6847H4.9967L8.14768 8.15239H6.10704L4.08235 13.2737L3.25615 8.93263C3.18038 8.4358 2.79659 8.15239 2.3268 8.15239H-0.926404ZM8.96825 8.15239L7.36744 15.6847H9.31336L10.9085 8.15239H8.96825ZM19.8213 8.15239C19.3521 8.15239 19.1035 8.4036 18.921 8.8426L16.0702 15.6847H18.1108L18.5056 14.5444H20.9917L21.2318 15.6847H23.0323L21.4615 8.15239H19.8213ZM20.0867 10.1874L20.6916 13.0139H19.0711L20.0867 10.1874Z",
    fill: "#1434CB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_65:169"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.57608012e02a860b07faa8da983e2ed1.svg";
export { ForwardRef as ReactComponent };